module.exports = __webpack_public_path__ + "img/trade-side-img-keyandmoney.0d54dbf3.jpeg";